import React, { useState } from "react";
import {
    faBuilding,
    faCalendar,
    faCircle,
    faComments,
    faEnvelope,
    faFemale,
    faGlobe,
    faHashtag,
    faHistory,
    faHome,
    faInfoCircle,
    faMale,
    faMoneyBillWave,
    faPhone,
    faPhoneVolume,
    faSitemap,
    faThermometerHalf,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";

import moment from "moment";
import "moment/locale/pt-br";

import SpinnerComponent from "../../Loding/Spinner";

import "./styles.css";
import { IAtendimento } from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import HTMLRemover from "../../Utils/HTMLRemover";
import ModalComponent from "../../Modais";
import CopyToClipboard from "../../Utils/CopyToClipboard";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import AtendimentosPorProdutoModal from "../AtendimentosPorProdutoModal";
import MenuAcoesDoCaso from "./MenuAcoesDoCaso";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { VerificarInadimplenciaProdutoController } from "../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import { useUserInfor } from "../../../Context/User";
import { FormatterCPF } from "../../../Validations/InputMasks";
import {
    formatedTelefone,
    formatMoneyReais,
    formatPhoneTelefonia,
} from "../../../Tools/FormatTools";
import EditarCliente from "../Geral/Cliente/DadosCadastraisCliente/EditarCliente";
import { IComponentModal } from "../../Modais/IModalComponent";

import { detectarTagsHtml } from "../../../Tools/FormatTools";
import DOMPurify from "dompurify";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { GetContatoContaController } from "../../../Controllers/Geral/Contatos/ContatosController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { EfetuarDiscagemController } from "../../../Controllers/Geral/Telefonia/TelefoniaController";
import { Spinner } from "../../Loding/SpinnerPadrao";
import Swal from "sweetalert2";
interface IInforCaso {
    Atendimento: IAtendimento;
    KPIsCard?: React.FC<any>;
}

export default function InforCaso(props: IInforCaso) {
    const [mostrarAtendimentosPorProduto, setMostrarAtendimentosPorProduto] =
        useState(false);
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;
    const { FUNCOES } = useUserInfor().UserInfor;

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        lstInforVendas,
        Cliente,
        ClienteLoading,
        GetCliente,
        dadosOportunidade,
    } = useAtendimentoPage();

    const { Atendimento } = props;

    const history = useHistory();
    const { id } = useModuloInfo();
    const linkTelaCliente =
        useModuloInfo().DS_LINK_TELA_CLIENTE ??
        ACESSOS.GERAL.TELAS.CLIENTE.DS_LINK;

    const dsProdutoCompSeparado = Atendimento.DS_PRODUTO_COMP?.split("-");

    const empreendimento = Atendimento.DS_PRODUTO_COMP?.split("-")[0] ?? "";
    const divEmp = empreendimento;
    // const divProd =
    //     produto?.replace(/^\s|\s$/gm, "") !==
    //     empreendimento.replace(/^\s|\s$/gm, "")
    //         ? `${produto} - `
    //         : "";
    const divUnidade =
        dsProdutoCompSeparado && dsProdutoCompSeparado.length === 3
            ? dsProdutoCompSeparado[1] + "-" + dsProdutoCompSeparado[2]
            : Atendimento.DS_PRODUTO;

    const emccampMode =
        ID_ORGANIZACAO === "E830AEF3-49DF-4DC1-8560-DC78EE448F01";

    const { value: inadimplenciaProduto } = useAsyncEffect(() =>
        VerificarInadimplenciaProdutoController(Atendimento.ID_CASO)
    );

    // const { value: lstInforVendas,  execute:getInforVendas} = useAsyncEffect(() =>
    //     getInforVendasController(Atendimento.ID_CASO)
    // );

    const { execute: efetuarDiscagem, loading: efetuarDiscagemLoading } =
        useAsyncCallback(EfetuarDiscagemController);
    const { value: getContatoConta, execute: getContatoContaExecute } =
        useAsyncEffect(async () => {
            if (Atendimento.ID_CONTATO)
                return GetContatoContaController(
                    String(Atendimento.ID_CONTATO)
                );
        }, [Atendimento.ID_CONTATO]);

    const umDiaEmMilissegundos = 1000 * 60 * 60 * 24;
    const dtSLA = new Date(Atendimento.DT_SLA || Date.now());
    const dtExpectativaInicialConclusao = new Date(
        Atendimento.DT_EXPECTATIVA_CONCLUSAO || Date.now()
    );
    const atendimentoClienteDtSLA = Atendimento.DT_FIM
        ? Math.round(
              (new Date(Atendimento.DT_FIM).getTime() - dtSLA.getTime()) /
                  umDiaEmMilissegundos
          )
        : Math.round((Date.now() - dtSLA.getTime()) / umDiaEmMilissegundos);

    const atendimentoClienteExpectativaRealConclusao = Atendimento.DT_FIM
        ? Math.round(
              (new Date(Atendimento.DT_FIM).getTime() -
                  dtExpectativaInicialConclusao.getTime()) /
                  umDiaEmMilissegundos
          )
        : Math.round(
              (Date.now() - dtExpectativaInicialConclusao.getTime()) /
                  umDiaEmMilissegundos
          );

    const removeMsOutlookMobileSignature = (html: string) => {
        return html.replace(/<style([\s\S]*?)<\/style>/gi, "");
    };

    const addEspacoEntreTags = (html: string) => {
        const sanitizedHTML = DOMPurify.sanitize(html);
        const htmlComEspacos = sanitizedHTML.replace(/(>)(<)/g, "$1 $2");
        return htmlComEspacos;
    };

    const descricaoCaso = addEspacoEntreTags(Atendimento.DS_CASO);

    const DS_IS_HTML = detectarTagsHtml(
        Atendimento.DS_CASO.includes("ms-outlook-mobile-signature") === true
            ? removeMsOutlookMobileSignature(Atendimento.DS_CASO)
            : Atendimento.DS_CASO
    );

    const handleNameClick = () => {
        history.push(linkTelaCliente(Atendimento.ID_CONTA));
    };

    let variant = "success";

    const percentual =
        (dadosOportunidade?.NR_PROBABILIDADE_FECHAMENTO ?? 0) * 100 || 0;

    if (percentual < 50) {
        variant = "primary";
    } else if (percentual >= 50 && percentual < 80) {
        variant = "warning";
    } else if (percentual >= 80) {
        variant = "danger";
    }

    return Atendimento.ID_CASO > 0 ? (
        <>
            <div className="card card-custom w-auto gutter-b icon-background">
                {
                    <i
                        style={{
                            color:
                                Atendimento.HX_COR_PESO_ATENDIMENTO ||
                                "#B5B5C3",
                            zIndex: 0,
                        }}
                        className={`z-1 ${
                            Atendimento.DS_ICON_PESO_ATENDIMENTO ||
                            "far fa-file-alt"
                        }`}
                    ></i>
                }

                <div className="card-header flex-wrap ribbon ribbon-top ribbon-ver ribbon">
                    <div className="ribbon-target-mult d-none d-sm-flex">
                        {ACESSOS.ATENDIMENTO.ID_MODULO === id && (
                            <>
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-sla">
                                            <strong>SLA:</strong>{" "}
                                            {atendimentoClienteDtSLA < 0 ? (
                                                <>
                                                    {Math.abs(
                                                        atendimentoClienteDtSLA
                                                    )}{" "}
                                                    Dias para Vencer
                                                </>
                                            ) : (
                                                <>
                                                    {atendimentoClienteDtSLA}{" "}
                                                    Dias em Atraso SLA
                                                </>
                                            )}
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className={`text-${
                                            atendimentoClienteDtSLA < 0
                                                ? "success"
                                                : atendimentoClienteDtSLA === 0
                                                ? "warning"
                                                : "danger"
                                        }`}
                                        style={{ top: "-2px" }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={`text-${
                                                atendimentoClienteDtSLA < 0
                                                    ? "success"
                                                    : atendimentoClienteDtSLA ===
                                                      0
                                                    ? "warning"
                                                    : "danger"
                                            } mt-3 mr-3`}
                                            size={"2x"}
                                        />
                                    </div>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="tooltip-expectativa">
                                            <strong>
                                                Expectativa Real de Conclusão:
                                            </strong>{" "}
                                            {atendimentoClienteExpectativaRealConclusao <
                                            0 ? (
                                                <>
                                                    {Math.abs(
                                                        atendimentoClienteExpectativaRealConclusao
                                                    )}{" "}
                                                    Dias para Vencer
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        atendimentoClienteExpectativaRealConclusao
                                                    }{" "}
                                                    Dias em Atraso SLA
                                                </>
                                            )}
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className={`text-${
                                            atendimentoClienteExpectativaRealConclusao <
                                            0
                                                ? "success"
                                                : atendimentoClienteExpectativaRealConclusao ===
                                                  0
                                                ? "warning"
                                                : "danger"
                                        }`}
                                        style={{ top: "-2px" }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faCircle}
                                            className={`text-${
                                                atendimentoClienteExpectativaRealConclusao <
                                                0
                                                    ? "success"
                                                    : atendimentoClienteExpectativaRealConclusao ===
                                                      0
                                                    ? "warning"
                                                    : "danger"
                                            } mt-3 mr-3`}
                                            size={"2x"}
                                        />
                                    </div>
                                </OverlayTrigger>
                            </>
                        )}
                        {Atendimento.DS_OCORRENCIA &&
                        emccampMode &&
                        ACESSOS.ASSISTENCIA.ID_MODULO === id ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Ocorrência
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="ribbon-target ribbonCustom bg-primary"
                                    style={{ top: "-2px" }}
                                >
                                    {Atendimento.DS_OCORRENCIA}
                                </div>
                            </OverlayTrigger>
                        ) : null}
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    ID Atendimento / Caso
                                </Tooltip>
                            }
                        >
                            <div
                                className="ribbon-target ribbonCustom bg-warning"
                                style={{ top: "-2px" }}
                            >
                                {Atendimento.ID_CASO}
                            </div>
                        </OverlayTrigger>

                        {/* {Atendimento.DS_OBSERVACAO &&
                        Atendimento.DS_OBSERVACAO !== null ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Observação
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="ribbon-target ribbonCustom bg-dark"
                                    style={{ top: "-2px" }}
                                >
                                    {Atendimento.DS_OBSERVACAO}
                                </div>
                            </OverlayTrigger>
                        ) : null} */}

                        <OverlayTrigger
                            overlay={
                                <Tooltip id="tooltip-disabled">
                                    Canal de Atendimento
                                </Tooltip>
                            }
                        >
                            <div
                                className="ribbon-target ribbonCustom bg-info"
                                style={{ top: "-2px" }}
                            >
                                <FontAwesomeIcon
                                    icon={faComments}
                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                />
                                {Atendimento.DS_TIPO_CANAL_ATENDIMENTO}
                            </div>
                        </OverlayTrigger>
                        {(Atendimento.DS_ATENDENTE ||
                            Atendimento.DS_USUARIO_RESPONSAVEL) && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Atendente
                                    </Tooltip>
                                }
                            >
                                <div
                                    className="ribbon-target ribbonCustom bg-success"
                                    style={{ top: "-2px" }}
                                >
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                    />
                                    {Atendimento.DS_ATENDENTE ||
                                        Atendimento.DS_USUARIO_RESPONSAVEL}
                                </div>
                            </OverlayTrigger>
                        )}
                        <MenuAcoesDoCaso />
                    </div>
                    <div
                        style={{ right: "10px", top: "10px" }}
                        className="d-flex align-items-center g-2  position-absolute d-sm-none"
                    >
                        <OverlayTrigger
                            overlay={
                                <Tooltip
                                    id="tooltip-disabled"
                                    className="d-flex flex-column"
                                >
                                    <div className="d-flex flex-column font-size font-weight-bold">
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faUser}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {Atendimento.DS_ATENDENTE ||
                                                Atendimento.DS_USUARIO_RESPONSAVEL}
                                        </div>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faComments}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {
                                                Atendimento.DS_TIPO_CANAL_ATENDIMENTO
                                            }
                                        </div>
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faHashtag}
                                                className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                            />
                                            {Atendimento.ID_CASO}
                                        </div>
                                    </div>
                                </Tooltip>
                            }
                        >
                            <div className="d-flex text-primary">
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    size="2x"
                                    className="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                                />
                            </div>
                        </OverlayTrigger>
                        <MenuAcoesDoCaso />
                    </div>

                    <div className="card-title">
                        <div className="d-flex flex-column flex-wrap align-items-start">
                            <div className="d-flex flex-column align-items-start justify-content-center flex-wrap text-break">
                                <span className="font-size-h3 font-weight-bold pb-2 pt-3">
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-disabled-cliente">
                                                Cliente Titular
                                            </Tooltip>
                                        }
                                    >
                                        <span
                                            onClick={handleNameClick}
                                            className="text-dark text-hover-primary mr-2 font-size-h3 font-weight-bold"
                                        >
                                            <FontAwesomeIcon
                                                icon={
                                                    (Cliente?.NR_CPF?.toString()
                                                        .length ?? 0) > 11
                                                        ? faBuilding
                                                        : Cliente?.DS_SEXO ===
                                                          "Masculino"
                                                        ? faMale
                                                        : Cliente?.DS_SEXO ===
                                                          "Feminino"
                                                        ? faFemale
                                                        : faUser
                                                }
                                                size="lg"
                                                className="text-success mr-2"
                                            />
                                            {Atendimento.DS_CONTA}
                                        </span>
                                    </OverlayTrigger>

                                    <CopyToClipboard className="mr-2">
                                        {Atendimento.DS_CONTA}
                                    </CopyToClipboard>

                                    {!FUNCOES.some(
                                        (f) =>
                                            f.NM_FUNCAO ===
                                            "ADM_BLOQUEAR_EDICAO_CONTAS"
                                    ) && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="tooltip-disabled-editar">
                                                    Editar
                                                </Tooltip>
                                            }
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-none  btn-xs mr-2"
                                                onClick={() => {
                                                    setShow(true);
                                                    setModal({
                                                        headerComponent:
                                                            "Dados Cadastrais",

                                                        Component: () => (
                                                            <EditarCliente
                                                                Cliente={
                                                                    Cliente
                                                                }
                                                                GetCliente={
                                                                    GetCliente
                                                                }
                                                                setShow={
                                                                    setShow
                                                                }
                                                            />
                                                        ),
                                                        scrollable: true,
                                                        size: "xl",
                                                    });
                                                }}
                                                disabled={ClienteLoading}
                                            >
                                                <i className="pl-1 flaticon-edit text-success icon-md"></i>
                                            </button>
                                        </OverlayTrigger>
                                    )}
                                </span>

                                {Cliente?.DS_OBSERVACAO && (
                                    <span className="form-text text-muted py-2">
                                        {Cliente?.DS_OBSERVACAO}
                                    </span>
                                )}
                            </div>{" "}
                            {ACESSOS.VENDAS.ID_MODULO === id && (
                                <div className="d-flex align-items-center w-100">
                                    <FontAwesomeIcon
                                        icon={faThermometerHalf}
                                        className={`text-${variant} mr-2`}
                                        size="lg"
                                    />
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="tooltip-disabled">
                                                {"Probabilidade de fechamento: " +
                                                    percentual +
                                                    "%"}
                                            </Tooltip>
                                        }
                                    >
                                        <ProgressBar
                                            variant={variant}
                                            now={percentual}
                                            label={`${percentual}%`}
                                            className="progress-xl w-100"
                                        />
                                    </OverlayTrigger>
                                </div>
                            )}
                            {Atendimento.NR_CPF && (
                                <span className="label font-size-normal font-weight-bolder label-light-info label-inline mr-2 my-1 h-auto">
                                    CPF {Atendimento.NR_CPF}
                                </span>
                            )}
                            {Atendimento.DS_EMAIL && (
                                <span className="label font-size-normal font-weight-bolder label-light-success label-inline mr-2 my-1 h-auto">
                                    {Atendimento.DS_EMAIL}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
                <div className="card-body p-4" style={{ zIndex: 5 }}>
                    <div className="d-flex">
                        <div className="flex-grow-1">
                            <div className="d-flex flex-wrap justify-content-between align-items-center">
                                <div className="d-flex flex-wrap flex-column align-items-center ">
                                    <div className="mr-3">
                                        <div className="font-weight-bold text-center">
                                            Data Inicial
                                        </div>
                                        <span className="label label-lg label-light-success label-inline text-uppercase font-weight-bold">
                                            {moment(
                                                Atendimento.DT_INICIO
                                            ).format("lll")}
                                        </span>
                                    </div>
                                    {ACESSOS.ATENDIMENTO.ID_MODULO === id && (
                                        <div className="mr-3 mt-2">
                                            <div className="font-weight-bold text-center">
                                                Expectativa de Conclusão
                                            </div>
                                            <span className="label label-lg label-light-success label-inline text-uppercase font-weight-bold">
                                                {moment(
                                                    Atendimento.DT_EXPECTATIVA_CONCLUSAO
                                                        ? Atendimento.DT_EXPECTATIVA_CONCLUSAO
                                                        : Atendimento.DT_SLA
                                                ).format("lll")}
                                            </span>
                                        </div>
                                    )}

                                    {Atendimento.DT_FIM && (
                                        <div className="mt-1 mr-3">
                                            <div className="font-weight-bold text-center">
                                                Data Final
                                            </div>
                                            <span className="label label-lg label-light-danger label-inline text-uppercase font-weight-bold">
                                                {moment(
                                                    Atendimento.DT_FIM
                                                ).format("lll")}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex flex-column w-75">
                                    {Atendimento.DS_CASO && (
                                        <div
                                            className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5"
                                            style={{
                                                whiteSpace: DS_IS_HTML
                                                    ? "normal"
                                                    : "pre-line",
                                            }}
                                        >
                                            <HTMLRemover>
                                                {descricaoCaso}
                                            </HTMLRemover>
                                        </div>
                                    )}
                                    {Atendimento.DS_MOTIVO_CANCELAMENTO && (
                                        <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5 ml-5">
                                            <p>
                                                <span className="font-weight-bolder">
                                                    Cancelado:
                                                </span>{" "}
                                                {
                                                    Atendimento.DS_MOTIVO_CANCELAMENTO
                                                }
                                            </p>
                                        </div>
                                    )}
                                </div>

                                <div className="pl-3 d-flex flex-wrap align-items-center justify-content-center my-2 mt-5">
                                    {ACESSOS.VENDAS.ID_MODULO !== id && (
                                        <div className="d-flex flex-nowrap align-items-center justify-content-center">
                                            <div
                                                className={`symbol symbol-45 ${
                                                    inadimplenciaProduto
                                                        ? "symbol-light-danger"
                                                        : "symbol-light-success"
                                                }`}
                                            >
                                                <div className="symbol-label">
                                                    <FontAwesomeIcon
                                                        icon={faHome}
                                                        size="lg"
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-left ml-2">
                                                {ACESSOS.ATENDIMENTO
                                                    .ID_MODULO === id ? (
                                                    <>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    id={`cnpjEmpreendimento`}
                                                                >
                                                                    <div>
                                                                        <strong>
                                                                            Escritório
                                                                            de
                                                                            Cobrança:
                                                                        </strong>{" "}
                                                                        {props
                                                                            .Atendimento
                                                                            ?.DS_BONIFICACAO
                                                                            ? props
                                                                                  .Atendimento
                                                                                  ?.DS_BONIFICACAO
                                                                            : "Sem Informação"}
                                                                    </div>
                                                                    {props
                                                                        .Atendimento
                                                                        .NR_SPE_CNPJ && (
                                                                        <div>
                                                                            <strong>
                                                                                CNPJ
                                                                                do
                                                                                Empreendimento:
                                                                            </strong>{" "}
                                                                            {FormatterCPF(
                                                                                props
                                                                                    .Atendimento
                                                                                    ?.NR_SPE_CNPJ ??
                                                                                    0
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <div>
                                                                        <strong>
                                                                            Cedido
                                                                            ao
                                                                            banco:
                                                                        </strong>{" "}
                                                                        {props
                                                                            .Atendimento
                                                                            .CEDIDO_BANCO
                                                                            ? props
                                                                                  .Atendimento
                                                                                  .CEDIDO_BANCO
                                                                            : "Sem informação"}
                                                                    </div>
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                                {divEmp}
                                                                <FontAwesomeIcon
                                                                    title="Histórico"
                                                                    cursor={
                                                                        "pointer"
                                                                    }
                                                                    onClick={() =>
                                                                        setMostrarAtendimentosPorProduto(
                                                                            true
                                                                        )
                                                                    }
                                                                    icon={
                                                                        faHistory
                                                                    }
                                                                    size="lg"
                                                                />
                                                            </div>
                                                        </OverlayTrigger>
                                                    </>
                                                ) : (
                                                    <>
                                                        {Atendimento?.NR_SPE_CNPJ ? (
                                                            <OverlayTrigger
                                                                overlay={
                                                                    <Tooltip
                                                                        id={`cnpjEmpreendimento`}
                                                                    >
                                                                        <div>
                                                                            <strong>
                                                                                Escritório
                                                                                de
                                                                                Cobrança:
                                                                            </strong>{" "}
                                                                            {props
                                                                                .Atendimento
                                                                                ?.DS_BONIFICACAO
                                                                                ? props
                                                                                      .Atendimento
                                                                                      ?.DS_BONIFICACAO
                                                                                : "Sem Informação"}
                                                                        </div>
                                                                        <div>
                                                                            <strong>
                                                                                CNPJ
                                                                                do
                                                                                Empreendimento:
                                                                            </strong>{" "}
                                                                            {FormatterCPF(
                                                                                props
                                                                                    .Atendimento
                                                                                    ?.NR_SPE_CNPJ ??
                                                                                    0
                                                                            )}
                                                                        </div>

                                                                        <div>
                                                                            <strong>
                                                                                Cedido
                                                                                ao
                                                                                banco:
                                                                            </strong>{" "}
                                                                            {props
                                                                                .Atendimento
                                                                                .CEDIDO_BANCO
                                                                                ? props
                                                                                      .Atendimento
                                                                                      .CEDIDO_BANCO
                                                                                : "Sem informação"}
                                                                        </div>
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                                    {divEmp}
                                                                    <FontAwesomeIcon
                                                                        title="Histórico"
                                                                        cursor={
                                                                            "pointer"
                                                                        }
                                                                        onClick={() =>
                                                                            setMostrarAtendimentosPorProduto(
                                                                                true
                                                                            )
                                                                        }
                                                                        icon={
                                                                            faHistory
                                                                        }
                                                                        size="lg"
                                                                    />
                                                                </div>
                                                            </OverlayTrigger>
                                                        ) : (
                                                            <div className="font-size-h6 text-dark-75 font-weight-bolder">
                                                                {divEmp}
                                                                <FontAwesomeIcon
                                                                    title="Histórico"
                                                                    cursor={
                                                                        "pointer"
                                                                    }
                                                                    onClick={() =>
                                                                        setMostrarAtendimentosPorProduto(
                                                                            true
                                                                        )
                                                                    }
                                                                    icon={
                                                                        faHistory
                                                                    }
                                                                    size="lg"
                                                                />
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                <div className="font-size-sm font-weight-bold mt-1">
                                                    {divUnidade}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {lstInforVendas && (
                                <>
                                    <hr />
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-between flex-wrap w-100">
                                            {lstInforVendas?.CONTA
                                                .NR_TELEFONE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faPhone}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Telefone
                                                            </span>

                                                            <span className="text-dark-75 font-weight-bold">
                                                                {formatedTelefone(
                                                                    lstInforVendas
                                                                        ?.CONTA
                                                                        .NR_TELEFONE
                                                                )}
                                                                <CopyToClipboard className="mx-2">
                                                                    {
                                                                        lstInforVendas
                                                                            ?.CONTA
                                                                            .NR_TELEFONE
                                                                    }
                                                                </CopyToClipboard>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {lstInforVendas?.CONTA.DS_EMAIL && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEnvelope
                                                                }
                                                                size="2x"
                                                                className="svg-icon icon-xl text-success d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Email
                                                            </span>

                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    lstInforVendas
                                                                        ?.CONTA
                                                                        .DS_EMAIL
                                                                }
                                                                <CopyToClipboard className="mx-2">
                                                                    {
                                                                        lstInforVendas
                                                                            ?.CONTA
                                                                            .DS_EMAIL
                                                                    }
                                                                </CopyToClipboard>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {lstInforVendas?.INTERESSE
                                                ?.DS_UN_INTERESSE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faHome}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-info d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Unidade de
                                                                Interesse
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    lstInforVendas
                                                                        ?.INTERESSE
                                                                        .DS_UN_INTERESSE
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {lstInforVendas?.ORIGEM
                                                ?.DS_ORIGEM_LEAD && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faGlobe}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Origem do Lead
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    lstInforVendas
                                                                        ?.ORIGEM
                                                                        .DS_ORIGEM_LEAD
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {dadosOportunidade?.VL_OPORTUNIDADE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-success mr-2">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMoneyBillWave
                                                                }
                                                                size="2x"
                                                                className="svg-icon icon-xl text-success d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Valor da
                                                                Oportunidade
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {formatMoneyReais(
                                                                    dadosOportunidade?.VL_OPORTUNIDADE
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {dadosOportunidade?.DT_FECHAMENTO && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faCalendar
                                                                }
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Expectativa de
                                                                fechamento
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {moment(
                                                                    dadosOportunidade?.DT_FECHAMENTO
                                                                ).format(
                                                                    "DD/MM/YYYY"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>{" "}
                                </>
                            )}

                            {getContatoConta && (
                                <>
                                    <hr />
                                    <div className="d-flex flex-column align-items-center">
                                        <div className="d-flex justify-content-center">
                                            <h6>
                                                Dados do Contato Abertura do
                                                Atendimento
                                            </h6>
                                        </div>
                                        <div className="d-flex justify-content-between w-100">
                                            {getContatoConta?.DS_NOME && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faUser}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Nome Contato
                                                            </span>

                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    getContatoConta.DS_NOME
                                                                }
                                                                <CopyToClipboard className="mx-2">
                                                                    {
                                                                        getContatoConta.DS_NOME
                                                                    }
                                                                </CopyToClipboard>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {getContatoConta?.NR_TELEFONE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex flex-wrap align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faPhone}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Telefone
                                                            </span>

                                                            <span className="text-dark-75 font-weight-bold">
                                                                {formatedTelefone(
                                                                    getContatoConta?.NR_TELEFONE ??
                                                                        ""
                                                                )}
                                                                <CopyToClipboard className="mx-2">
                                                                    {
                                                                        getContatoConta?.NR_TELEFONE
                                                                    }
                                                                </CopyToClipboard>
                                                            </span>
                                                        </div>
                                                        <OverlayTrigger
                                                            overlay={
                                                                <Tooltip
                                                                    id={`discagem`}
                                                                >
                                                                    Discar
                                                                </Tooltip>
                                                            }
                                                            placement="bottom"
                                                        >
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-success"
                                                                disabled={
                                                                    efetuarDiscagemLoading
                                                                }
                                                                onClick={() => {
                                                                    if (
                                                                        getContatoConta?.NR_TELEFONE &&
                                                                        props
                                                                            .Atendimento
                                                                            .ID_CASO
                                                                    ) {
                                                                        const telefone =
                                                                            getContatoConta.NR_TELEFONE;
                                                                        const ddd =
                                                                            telefone.substring(
                                                                                0,
                                                                                2
                                                                            );
                                                                        const numero =
                                                                            telefone.substring(
                                                                                2
                                                                            );

                                                                        Swal.fire(
                                                                            {
                                                                                title: "Confirmar ligação",
                                                                                text: `Deseja realizar uma ligação para ${formatedTelefone(
                                                                                    telefone
                                                                                )}?`,
                                                                                icon: "question",
                                                                                showCancelButton:
                                                                                    true,
                                                                                confirmButtonText:
                                                                                    "Sim",
                                                                                cancelButtonText:
                                                                                    "Não",
                                                                            }
                                                                        ).then(
                                                                            (
                                                                                result
                                                                            ) => {
                                                                                if (
                                                                                    result.isConfirmed
                                                                                ) {
                                                                                    efetuarDiscagem(
                                                                                        formatPhoneTelefonia(
                                                                                            ddd,
                                                                                            numero
                                                                                        ),
                                                                                        props
                                                                                            .Atendimento
                                                                                            .ID_CASO
                                                                                    ).then(
                                                                                        () => {
                                                                                            getContatoContaExecute();
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }
                                                                        );
                                                                    }
                                                                }}
                                                            >
                                                                {efetuarDiscagemLoading ? (
                                                                    <Spinner size="sm" />
                                                                ) : (
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faPhoneVolume
                                                                        }
                                                                    />
                                                                )}
                                                            </button>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                            )}
                                            {getContatoConta.DS_EMAIL && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faEnvelope
                                                                }
                                                                size="2x"
                                                                className="svg-icon icon-xl text-success d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Email
                                                            </span>

                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    getContatoConta.DS_EMAIL
                                                                }
                                                                <CopyToClipboard className="mx-2">
                                                                    {
                                                                        getContatoConta.DS_EMAIL
                                                                    }
                                                                </CopyToClipboard>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {getContatoConta.DS_TIPO_RELACAO_CLIENTE && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faSitemap}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-info d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Tipo de Relação
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    getContatoConta.DS_TIPO_RELACAO_CLIENTE
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {/* {getContatoConta.DS_ORIGEM_LEAD && (
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 mr-5 ml-5">
                                                    <div className="d-flex align-items-center py-2">
                                                        <div className="symbol symbol-primary mr-2">
                                                            <FontAwesomeIcon
                                                                icon={faGlobe}
                                                                size="2x"
                                                                className="svg-icon icon-xl text-primary d-lg-flex"
                                                            />
                                                        </div>
                                                        <div className="d-flex flex-column text-left">
                                                            <span className="text-muted font-weight-bold">
                                                                Origem do Lead
                                                            </span>
                                                            <span className="text-dark-75 font-weight-bold">
                                                                {
                                                                    getContatoConta.DS_ORIGEM_LEAD
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            )} */}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
                {props.KPIsCard && (
                    <div className="card-footer d-flex justify-content-between pt-3 pb-3 pr-5">
                        <props.KPIsCard />
                    </div>
                )}
            </div>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />

            <ModalComponent
                setShow={setMostrarAtendimentosPorProduto}
                show={mostrarAtendimentosPorProduto}
                ModalComponent={{
                    size: "xl",
                    Component: () => (
                        <AtendimentosPorProdutoModal
                            idProduto={Atendimento.ID_PRODUTO}
                        />
                    ),
                    headerComponent: "Atendimentos por Produto",
                }}
            />
        </>
    ) : (
        <SpinnerComponent />
    );
}
